import { P2PMarketRangePrice } from '@Redux/interfaces/p2p'

import { getDataWrapper } from '@App/api/helper'
import { $host } from '@App/api/index'
import { IDataResponse } from '@App/api/interfaces'

export const getFiatRates = async (): Promise<IDataResponse<P2PMarketRangePrice[]>> =>
  await getDataWrapper($host.get(`api/currencies/rates`))
